// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__PBOyb","title":"Category_title__DK1bL","subTitleContainer":"Category_subTitleContainer__ujM7s","subTitle":"Category_subTitle__NtDnb"};